var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bg-form-wrapper',{attrs:{"label":_vm.label,"name":_vm.name,"size":_vm.size,"prefill":_vm.prefill}},[_c('select2',{staticClass:"collection-select collection-select--inline",attrs:{"name":"CountryIso","value":_vm.value,"data":_vm.options},on:{"update":selected => _vm.value = selected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }